import { ScrollToApplyButton } from 'components/ApplyButton/ScrollToApplyButton';
import { DesktopOnly } from 'components/Breakpoint/DesktopOnly';
import { DropdownMenuItem } from 'components/Dropdown/menus/Menu/Item/DropdownMenuItem';
import { SaveListingButton } from 'components/SaveButton/SaveListingButton';
import { ShareListingButton } from 'components/ShareListingButton/ShareListingButton';
import type { ApiJob } from 'modules/listing/api/job/types/ApiJob';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { ListingActionsDropdownMarkApplied } from 'modules/listing/components/ListingActionsDropdown/ListingActionsDropdownMarkApplied';
import { ListingViewActionButtons } from 'modules/listing/components/ListingView/ActionButtons/ListingViewActionButtons';
import type { OrgDashboardApiJob } from 'modules/orgDashboard/api/listing/types/OrgDashboardApiJob';

type Props = {
  job: ApiJob | OrgDashboardApiJob;

  applied: boolean;
  onMarkAsApplied: () => Promise<void>;
  onMarkAsNotApplied: () => Promise<void>;

  // Save job
  jobSaved: boolean;
  onSaveJob: () => Promise<void>;
  onUnsaveJob: () => Promise<void>;

  // Save Org
  orgSaved: boolean;
  shouldShowSaveOrgTooltip: boolean;
  onSaveOrg: () => Promise<void>;
  onUnsaveOrg: () => Promise<void>;
  onDismissSaveOrgTooltip: () => void;
};

export function ViewJobActionButtons({
  job,
  applied,
  onMarkAsApplied,
  onMarkAsNotApplied,
  jobSaved,
  onSaveJob,
  onUnsaveJob,
  orgSaved,
  shouldShowSaveOrgTooltip,
  onSaveOrg,
  onUnsaveOrg,
  onDismissSaveOrgTooltip,
}: Props) {
  const { id, hasAts, type, url, org } = job;

  return (
    <ListingViewActionButtons>
      <ScrollToApplyButton
        atsIsEnabled={hasAts}
        size="medium"
        applied={applied}
      />

      <SaveListingButton
        listingType={type}
        listingSaved={jobSaved}
        onSaveListing={onSaveJob}
        onUnsaveListing={onUnsaveJob}
        orgDetails={{
          shouldShowSaveOrgTooltip,
          onSaveOrg,
          onDismissSaveOrgTooltip,
        }}
      />

      <DesktopOnly>
        <ShareListingButton
          disabled={!url}
          listingId={id}
          listingType={type}
          listingUrl={url}
        />
      </DesktopOnly>

      <ListingActionsDropdown
        listingId={id}
        listingType={type}
        listingUrl={url}
        orgDetails={
          org
            ? {
                orgId: org.id,
                orgName: org.name,
                orgType: org.orgType,
                orgSaved,
                onSaveOrg,
                onUnsaveOrg,
              }
            : null
        }
        markAsAppliedButton={
          !hasAts && (
            <DropdownMenuItem>
              <ListingActionsDropdownMarkApplied
                applied={applied}
                onMarkAsApplied={onMarkAsApplied}
                onMarkAsNotApplied={onMarkAsNotApplied}
              />
            </DropdownMenuItem>
          )
        }
      />
    </ListingViewActionButtons>
  );
}
